import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context';

export const AuthRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);
  return !isLoggedIn ? <Outlet /> : <Navigate to="/works" />;
};
